import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ModalGallery from "../../components/Modal/ModalGallery";
import { useDispatchApp } from "../../lib/redux";
import { getPathDatabaseByRole } from "../../actions/auth";
import {
  ADS_CAMPAIGN_CAROUSEL_FORMAT,
  IMAGE_FORMATS,
  ROUTE_CAMPAIGNS,
  ROUTE_GALLERY,
  VIDEO_FORMATS,
} from "../../utils/constants";
import { PENDING_CONTENT_APPROVAL_REVIEW_STORAGE_KEY } from "../../components/ContentApproval/contentApprovalUtils";

const GalleryRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(true);
  const [initialContentReviewID, setInitialContentReviewID] = useState(null);

  const dispatch = useDispatchApp();
  const { userID } = dispatch(getPathDatabaseByRole());

  useEffect(() => {
    const pendingContentID = sessionStorage.getItem(
      PENDING_CONTENT_APPROVAL_REVIEW_STORAGE_KEY
    );

    if (pendingContentID) {
      sessionStorage.removeItem(PENDING_CONTENT_APPROVAL_REVIEW_STORAGE_KEY);
      setInitialContentReviewID(pendingContentID);
    }
  }, []);

  const onCloseGallery = useCallback(() => {
    setModalOpen(false);
    setInitialContentReviewID(null);

    const backgroundLocation = location.state?.galleryBackgroundLocation;
    if (
      backgroundLocation?.pathname &&
      backgroundLocation.pathname !== ROUTE_GALLERY
    ) {
      navigate(
        {
          pathname: backgroundLocation.pathname,
          search: backgroundLocation.search || "",
          hash: backgroundLocation.hash || "",
        },
        { replace: true, state: backgroundLocation.state }
      );
      return;
    }

    navigate(ROUTE_CAMPAIGNS, { replace: true });
  }, [location.state, navigate]);

  const onInitialContentReviewConsumed = useCallback(() => {
    setInitialContentReviewID(null);
  }, []);

  return (
    <ModalGallery
      modalOpen={modalOpen}
      onCloseModal={onCloseGallery}
      multiple={true}
      isOutsideCampaign={true}
      acceptedFormats={IMAGE_FORMATS.concat(VIDEO_FORMATS).concat(
        ADS_CAMPAIGN_CAROUSEL_FORMAT
      )}
      pathStorage={`socialMedia/${userID}/`}
      modeUpload="sync"
      onCallbackSelectedItems={() => {}}
      closeActionsDisabled={true}
      initialContentReviewID={initialContentReviewID}
      onInitialContentReviewConsumed={onInitialContentReviewConsumed}
      enableHistoryManagement={false}
    />
  );
};

export default GalleryRoute;
